export const NEW_PRODUCT_LIST_DESIGN_ENABLE = 'seller.office.new.product.listing.show.enable';
export const NEW_PRODUCT_CREATE_DESIGN_ENABLE = 'seller.office.new.product.create.show.enable';
export const NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE = 'seller.office.new.bulk.product.management.show.enable';
export const DEAL_LISTING_PAGE_SIZES = 'so.product.deal.listing.page.sizes';
export const SUB_ACCOUNT_LIMIT = 'seller.office.subAccount.limit';
export const NEW_PRODUCT_LISTING_SHOW_ENABLE = 'seller.office.new.product.listing.show.enable';
export const NEW_PRODUCT_CREATE_SINGLE_SHOW_ENABLE = 'seller.office.new.create.single.product.show.enable';
export const PRODUCT_DETAIL_SHOW_ENABLE = 'seller.office.new.product.detail.show.enable';
export const CHATBOT_ENABLED = 'seller.office.chatbot.enabled';
export const CHATBOT_URL = 'seller.office.chatbot.url';
